import { Form, Formik, Field } from "formik";
import { Button } from "../Button";
import { useRevalidator, useRouteLoaderData } from "react-router";
import { KlientkontoerklaeringByIdLoaderData } from "../../routes/klientkontoerklaering/KlientkontoerklaeringById";
import PageError from "../../routes/PageError";
import { parseDateString } from "../../util/date";
import { putKlientkontoErklaering } from "../../api/klientkontoerklaering";
import { KKE_FORM_VERSION } from "../../constants/config";
import { replacer } from "../../util/json";
import { Signeringstype } from "../../interfaces/api";
import UnderskrivModal from "../Modal/UnderskrivModal";
import { ModalProvider, ModalTrigger } from "../Modal/Modal";
import { getHtmlResultSimple } from "./HtmlResultSimple";

const KlientkontoerklaeringIntetTilsvar = ({
  loaderRouteId,
}: {
  loaderRouteId: string;
}) => {
  const { kke, metadata, error } = useRouteLoaderData(
    loaderRouteId,
  ) as KlientkontoerklaeringByIdLoaderData;
  const revalidator = useRevalidator();

  if (error) return <PageError />;
  if (kke?.status && kke.status !== "Kladde")
    return <PageError msg={`Erklæringen er ${kke.status.toLowerCase()}`} />;

  if (metadata) {
    // HVIS DER ÆNDRES I INDHOLDET af formTitle SKAL DER MULIGVIS ÆNDRES BACKEND DA formTitle BEHANDLES I BACKEND FOR IS-ERKLÆRINGER!
    // formTitle findes 3 steder i dette projekt!!!
    const formTitle = `Erklæring vedr. klienttilsvar m.v. pr. ${parseDateString(
      metadata.slutDato,
    )} for 
    ${metadata.person ? metadata.person.navn : ""}${
      metadata.firma
        ? metadata.firma.navn + ", CVR-nr. " + metadata.firma.cvr
        : ""
    }`;

    const signeringstype: Signeringstype = "Klientkontoerklaering";
    const values = {
      intet_tilsvar_confirm: false,
    };

    return (
      <Formik
        initialValues={values}
        onSubmit={() => {
          // swallow event
        }}
      >
        {({ handleSubmit, values }) => (
          <Form onSubmit={handleSubmit} className="card">
            <div className="card-header">
              <h2 className="display-2">{formTitle}</h2>
            </div>
            <div className="card-body">
              <div className="rounded border shadow-sm">
                <div className="form-check form-check--btn form-check--btn-lg">
                  <Field
                    className="form-check-input"
                    type="checkbox"
                    name="intet_tilsvar_confirm"
                    id="intet_tilsvar_confirm"
                  />
                  <label
                    className="form-check-label"
                    htmlFor="intet_tilsvar_confirm"
                  >
                    <span>
                      {metadata?.firma?.cvr ? "Advokatselskabet" : "Jeg"}&nbsp;
                    </span>
                    har ikke været i besiddelse af betroede midler i det
                    forløbne år. (Sæt kryds)
                  </label>
                </div>
              </div>
              <div className="mt-5">
                <ModalProvider>
                  <ModalTrigger asChild>
                    <Button
                      type="submit"
                      className="btn btn-lg btn-primary"
                      disabled={!values.intet_tilsvar_confirm}
                    >
                      Godkend og indsend
                    </Button>
                  </ModalTrigger>
                  <UnderskrivModal
                    isFinal={values.intet_tilsvar_confirm}
                    onSubmitHandler={async ({ email }) => {
                      try {
                        const mail = email ? email : null;
                        const jsonData = {
                          form: values,
                          version: KKE_FORM_VERSION,
                          kvittering_emailadresse: {
                            advokat: mail,
                            revisor: null,
                          },
                        };
                        if (!kke.revisorSigneret) {
                          await putKlientkontoErklaering({
                            id: kke.id,
                            jsonData: JSON.stringify(jsonData, replacer),
                            formular: getHtmlResultSimple(metadata),
                            formularType: "Formular2",
                          });
                        }
                        if (revalidator.state === "idle") {
                          revalidator.revalidate();
                        }
                        window.location.href = `${
                          import.meta.env.VITE_BACKEND_ENDPOINT
                        }/Signering/Signer?erklaeringId=${
                          kke.id
                        }&signeringstype=${signeringstype}`;
                      } catch (error) {
                        console.error(error);
                      }
                    }}
                  />
                </ModalProvider>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    );
  } else {
    if (error) {
      if (error === 404) {
        return <PageError msgText={"Erklæringen kunne ikke findes"} />;
      }
      return <PageError msg={`Erklæringen fejlede med en status ${error}`} />;
    } else {
      return (
        <PageError
          msg="Hov, person findes ikke!"
          msgText="Personen tilknyttet erklæringen kunne ikke findes i systemet"
        />
      );
    }
  }
};

export default KlientkontoerklaeringIntetTilsvar;
